var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3307 14C13.3307 13.0696 13.3307 12.6044 13.2159 12.2259C12.9574 11.3736 12.2904 10.7067 11.4382 10.4482C11.0596 10.3333 10.5944 10.3333 9.66406 10.3333H6.33073C5.40035 10.3333 4.93517 10.3333 4.55663 10.4482C3.70437 10.7067 3.03742 11.3736 2.77889 12.2259C2.66406 12.6044 2.66406 13.0696 2.66406 14M10.9974 5C10.9974 6.65685 9.65425 8 7.9974 8C6.34054 8 4.9974 6.65685 4.9974 5C4.9974 3.34315 6.34054 2 7.9974 2C9.65425 2 10.9974 3.34315 10.9974 5Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser01);
export default __webpack_public_path__ + "static/media/user-01.06835b8b44ec6c8ccc4e2f3676ea21fa.svg";
export { ForwardRef as ReactComponent };